const NAMES = {
  VEHICLE: 'Pojazd',
  ESTATE: 'Nieruchomość',
  CHILD: 'Dziecko',
  TRUCK: 'Samochód ciężarowy',
};

export default NAMES;
